export default ({ noIdeology, yesIdeology, noSociety, yesSociety }) => {
  const quotes = [
    [
      `Türkiye'nin en büyük “${noIdeology} grubu” ${noSociety}lerdir.`,
      `Külahıma anlat.`,
      `${noIdeology} demenin ne demek olduğunu biz ${yesSociety} kadar iyi kimse bilemez.`,
      `Tellak ${noSociety} var.`,
      `Midyeci ${noSociety} var.`,
      `Hurdacı ${noSociety} var.`,
      `Minibüsçü ${noSociety} var.`,
      `Pastaneci ${noSociety} var.`,
      `${noIdeology} salgın gibidir.`,
      `Siz hadiseyi hâlâ savaştan kaçan talihsiz insanlar olarak görüyorsanız… Beş sene sonra belki dank eder!`,
    ],
  ];

  return quotes[0];
};
